export default "__VITE_ASSET__CMCmtB1k__"